module.exports = __webpack_public_path__ + "static/img/goDaFang.c745ab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/goDaFang.png
// module id = eSXE
// module chunks = 1